import React from "react";
import { Button, Modal } from "semantic-ui-react";
import { useIntl } from "react-intl";

interface ModalUnauthrizedUserProps {
  open: boolean;
  onClose: () => void;
}

const DEFAULT_PROPS = {
  open: false,
  onClose: (() => {})
}

const ModalUnauthrizedUser = (propsParam: ModalUnauthrizedUserProps) => {
  const props = {
    ...DEFAULT_PROPS,
    ...Object.fromEntries(Object.entries(propsParam).filter(([_, value])=> value !== undefined)),
  };

  const intl = useIntl();
  return ( 
  <Modal size='tiny' open={props.open} onClose={props.onClose}>
    <Modal.Header>ขออภัยท่านไม่สามารถเข้าถึงผลการตรวจนี้ได้</Modal.Header>
    <Modal.Content>
      <p>{intl.formatMessage({ id: "เนื่องจากปัญหาด้านสิทธิการเข้าถึง กรุณาติดต่อ Admin เพื่อดำเนินการต่อ!" })}</p>
    </Modal.Content>
    <Modal.Actions>
      <Button negative onClick={props.onClose}>Close</Button>
    </Modal.Actions>
  </Modal>
  )
}


export default ModalUnauthrizedUser;